
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/credit-contract-preparation-list",
      function () {
        return require("private-next-pages/admin/credit-contract-preparation-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/credit-contract-preparation-list"])
      });
    }
  